import Component from '../core/Component'
import EventBus from '../core/EventBus'

export default class ProductForm extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            // submit: null, //----ajax prekreslnuje, je to potreba queryselectit pokazdy
            size: null
        }
        this.changeVariantUrl = this.element.dataset.changeVariantUrl

        this.validateAfterChange = false
    }

    prepare() {
        if (this.ref.size) {
            this.ref.size.addEventListener('change', this.handleSizeChange)
        }
        this.element.addEventListener('click', this.handleClick)
        this.element.addEventListener('change', this.handleChange)
    }

    handleClick = event => {
        const submitButton = event.target.closest('[data-ref="ProductForm:submit"]')
        if (!submitButton) {
            return
        }

        event.preventDefault()

        if (this.ref.size) {
            this.validateSize()
        } else {
            this.submit()
        }
    }

    handleChange = event => {
        if (this.validateAfterChange) {
            this.validateSize()
        }
    }

    handleSizeChange = event => {
        const variant = event.target.value
        let url = this.changeVariantUrl
        url = url.replace(`__VARIANT__`, variant)

        $.nette.ajax({
            url,
            beforeSend: () => {
                this.element.classList.add('is-changing-variant')
            },
            complete: () => {
                this.element.classList.remove('is-changing-variant')
            }
        })

        EventBus.emit('sizes:select:change', {
            value: variant
        })
    }

    validateSize(event) {
        const size = Component.getFromElement(this.ref.size)
        const input = this.ref.size.querySelector('input[type="radio"]:checked')

        if (!input) {
            this.validateAfterChange = true
            size.addError('Vyberte nejprve velikost')
            EventBus.emit('overlay:open')
        } else if (this.is('is-changing-variant')) {
            // nedelat nic... je out of stock a zobrazi se hlidaci pes
        }  else {
            size.removeError()
            this.submit()
        }
    }

    submit() {
        // FIXME: rewrite as function
        this.element.classList.add('is-loading')
        $.nette.ajax({
            url: this.element.action,
            method: this.element.method || 'GET',
            dataType: 'JSON',
            data: $(this.element).serialize(),
            success: () => {
                EventBus.emit('cart:open')
                if (window.dataLayer && this.element.dataset.gtmFormEvent) {
                    try {
                        const data = JSON.parse(this.element.dataset.gtmFormEvent)
                        window.dataLayer.push(data)
                    } catch (error) {

                    }
                }
            },
            complete: () => {
                this.element.classList.remove('is-loading')
                this.validateAfterChange = false
            }
        })
    }
}